import React from "react";
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import  { withStyles } from  '@material-ui/core/styles';
import SonicGrid from '../lib/SonicGrid'
import RefundAgreement from './RefundAgreement'
//import LeadFormDialog from './LeadFormDialog'
import moment from 'moment';

function isEmpty(obj) {

  if (obj){
    return Object.keys(obj).length === 0 ;
  }
  return true
}

const styles = theme => ({
  root: {
    backgroundColor: '#5DE3FE',
    width: '100%'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
 //   padding: theme.spacing(2, 4, 3),
  },
})


const TABLE_COLUMNS = [
    {id:'soldDate', label:'Date', numeric: false, disablePadding: false  },
    {id:'campaignName', label:'Campaign Name', numeric: false, disablePadding: false  },
    {id:'firstName', label:'First_Name', numeric: false, disablePadding: false  },
    {id:'lastName', label:'Last_Name', numeric: false, disablePadding: false  },
    {id:'phone', label:'Phone', numeric: false, disablePadding: false  },
    {id:'email', label:'Email', numeric: false, disablePadding: false  },
    {id:'region', label:'Region', numeric: false, disablePadding: false  },
    {id:'ageRange', label:'Age', numeric: false, disablePadding: false  },
    {id:'income', label:'Income', numeric: false, disablePadding: false  },
    {id:'keyword', label:'Keyword', numeric: false, disablePadding: false  },
    {id:'postalCode', label:'Postal_Code', snumeric: false, disablePadding: false  },
    {id:'household', label:'Household', numeric: false, disablePadding: false  },
    {id:'povertyLevel', label: 'Poverty_Level', numeric: false, disablePadding: false  },
    {id:'condition', label:'Condition', numeric: false, disablePadding: false  },
    {id:'leadType', label:'leadType', numeric: false, disablePadding: false  },
    {id:'qualifier', label:'qualifier', numeric: false, disablePadding: false  },
    {id:'individual', label:'Individual', numeric: false, disablePadding: false  },
    {id:'pregnant', label:'Pregnant', numeric: false, disablePadding: false  },
    {id:'leadPrice', label:'Price', numeric: false, disablePadding: false  },
    {id:'crmContactID', label:'Contact Id', numeric: false, disablePadding: false  },
    {id:'lastResult', label:'Last Result', numeric: false, disablePadding: false  },
    {id:'actions', label:'Actions', numeric: false, disablePadding: false  },
    {id:'comment', label:'Comment', numeric: false, disablePadding: false  },
    {id:'keywordRating', label:'Keyword Rating', numeric: false, disablePadding: false  },
    {id:'destinationEmailID', label:'Destination EmailID', numeric: false, disablePadding: false  },
    {id:'crmContactID', label:'Contact Id', numeric: false, disablePadding: false  },
    {id:'vertical', label:'Vertical', numeric: false, disablePadding: false  },
    {id:'id', label:'Lead Id', numeric: false, disablePadding: false  },
    {id:'soldEpoch', label:'Sold Epoch', numeric: false, disablePadding: false  },
    ];


@inject("commonStore")
@inject("authStore")
@observer
class Leads extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Leads',
      interval: 60000,
      columns: TABLE_COLUMNS,
      loading: false,
      selected: [], 
      lastActionedLead:null,
      showRefundTermsAgreement: false,
     // showForm: false,
      startDate: moment().startOf('day'),
      endDate:   moment(),
      showPurchase: false,
      showCustomDateRange: false,
      selectedCampaign: null,
      selectedLastResult: null,
      selected_leadType:null,
      selected_qualifier:null,
      selected_contactType:null,
      lastRefreshed: moment(),
      refreshScroll: false
    }
  }
  async componentDidMount() {
    const {startDate, endDate } = this.state
    const { authStore } = this.props

    const params = {
      startDate: startDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
      endDate: endDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
      campaignID: null,
      lastResult: null,
      leadType: null,
      qualifier: null,
      size: 25,
      count: 0,
      filters: []
    }
    authStore.getLeads(params)
    .then(result => {
      if(result){
        this.setAutoRefresh()
        return   this.props.authStore.getCampaigns(moment().subtract(190,'day').format('YYYY-MM-DDTHH:mm:ss.SSSZZ'), moment().format('YYYY-MM-DDTHH:mm:ss.SSSZZ'), 500, 0)
      }
    })
  }
  handleDateChange = (type, date) => {

    const temp = {}
    temp[type] = moment(date)
    this.setState(temp)
  }

  getLead = (leadID) => {
    const { commonStore: { leads } } = this.props
    let items = leads.filter((item) => {
      return item.leadID === leadID
    })

    if(items.length > 0){
      return items[0]
    }else{
      return null
    }
  }
  refreshLeads = (refreshPayload) => {
    const { authStore } = this.props
    authStore.getNowLeads(refreshPayload)
    .then((result) => {
      console.log(result)
      this.setAutoRefresh()
    })
    .catch(err => {
      console.log(err)
    })

  }
  setScrollExpiration = () => {
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => {this.setState({refreshScroll: true})}, 3600000)
  }
  setAutoRefresh = () => {
    console.log('setAutoRefresh leads')

    const { interval, endDate, selectedCampaign, selectedLastResult, selected_leadType, selected_qualifier, selected_contactType  } = this.state
  

    clearTimeout(this.timer)
    if(moment().diff(endDate, 'days') === 0){
      console.log('refreshDates')
      const refreshPayload = {
      startDate: moment().subtract(5, 'minute'), 
      endDate: moment(),
      campaignID: selectedCampaign,
      lastResult: selectedLastResult,
      leadType: selected_leadType,
      qualifier: selected_qualifier,
     // contactType: selected_contactType,
      size: 100,
      count: 0,
      filters: []
    }
      console.log(refreshPayload)
      this.timer = setTimeout(() => {this.refreshLeads(refreshPayload)}, interval)
    }
   // this.timer = setTimeout(this.getItems, interval)
  }
  toggleCustomDateRange = () => {
    const { showCustomDateRange } = this.state
    this.setState({showCustomDateRange: !showCustomDateRange})
  }
  /*handleCloseForm = (values) => {
    console.log(values)
      console.log(isEmpty(values))
    if (!(isEmpty(values))){
      const { selectedItem } = this.state
      const updatedItem = {orderID: selectedItem.id, ...values}
      console.log(updatedItem)
      this.props.authStore.updateLead(updatedItem)
    }
    this.setState({ showForm: false })
  }*/

  searchStringChanged = (value) => {
    //for initaiting a new queury from the search bar
      console.log(value)
  }
  campaignSelected = (campaignID) => {
    console.log('campaignSelected')
    console.log(campaignID)
    this.setState({selectedCampaign: campaignID}, () => {
      this.getItems()
    })
  }
  lastResultSelected = (lastResult) => {
    console.log('lastResultSelected')
    console.log(lastResult)
    this.setState({selectedLastResult: lastResult}, () => {
      this.getItems()
    })
  }
  filterSelected = (item) => {
    const key = Object.keys(item)
    this.setState({[`selected_${key}`]: item[key]}, () => {
      this.getItems()
    })
  }
  searchDatesUpdated = (dates) => {
    //console.log(type)
    console.log('searchDatesUpdated')
    console.log(dates)
   // this.getItems(dates)

    this.setState({...dates}, () => {
      this.getItems(dates)
    })

    
  }
  /*searchDateUpdated = (type, date) => {
    console.log(type)
    console.log(date)
    const temp = {}
    temp[type] = date
   
    this.setState(temp, () => {
      this.getItems()
    })


  }*/


  handleRefundTermsAgreementClose = (payload) => {
    console.log('handleRefundTermsAgreementClose')
    const { authStore } = this.props
    console.log(payload)
    if(payload){
      authStore.updateLead(payload)
    }

    this.setState({ showRefundTermsAgreement: false }) 

  };
  searchMore = () => {
    const { startDate, endDate, refreshScroll } = this.state
    const { leads, leadScrollID } =  this.props.commonStore
    const { authStore } = this.props
    const countOfLeadsToGet = leads.length + 25

    if(refreshScroll){
      console.log('should refreshScroll')
      this.getItems({startDate, endDate}, countOfLeadsToGet)
    }else{
      authStore.getMoreLeads(leadScrollID)
      .then(result => {
        if(result){
          this.setAutoRefresh()
        }else{
          //need to show auto refresh is off
        }
      })
    }

  }

  getItems = (dates, size) => {

    const {selectedCampaign, selectedLastResult} = this.state
    let { startDate, endDate } = this.state

    if(dates){
      startDate = dates.startDate
      endDate = dates.endDate
    }
    
  //  const {startDate, endDate} = dates

    console.log('startDate')
    console.log(startDate)

    console.log('endDate')
    console.log(endDate)

    const params = {
      startDate: startDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
      endDate: endDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
      campaignID: selectedCampaign,
      lastResult: selectedLastResult,
      size: size ? size : 25,
      count: 0,
      filters: []
    }

    this.props.authStore.getLeads(params)
    .then(result => {
      if(result){
        //this.setState({lastRefreshed: moment()})
        this.setAutoRefresh()
        this.setScrollExpiration()
      }else{
        //need to show auto refresh is off
      }
    })

  }
  itemSelected = (ids) => {
    const id = ids[0] //this form is only made for one item

    const { leads } = this.props.commonStore
 //   let items = mobx.toJS(leads)

     const foundItems = leads.filter(item => {
       return item.id === id
     })

    if (foundItems.length > 0){
    //  this.setState({ showForm: true, selectedItem: foundItems[0] })
    }
  }
  updateItem = (item) => {   
    const { authStore } = this.props
    const {id, value, type} = item

    const update = {leadID: id}
    update[type] = value
    authStore.updateLead(update)
    
    if(type === 'lastResult'){
      if(value === 'Non-Working Number'){
        this.setState({ showRefundTermsAgreement: true, lastActionedLead: id, lastActionType:type, lastActionRequested: value })
      }else{
        authStore.updateLead(update)
      }
    }else{
      authStore.updateLead(update)
    }

  }
  createDataArray = () => {
    const { columns } = this.state 
    const { leads } = this.props.commonStore
  //  let items = mobx.toJS(leads)

    const columnIds = columns.map(column => {
        return column.id
    })

    const items = leads.map(item => {
      const newItem = {};

      columnIds.forEach(key => {
        newItem[key] = item[key]
      })
      return newItem
    })

    return items

  }

  render() {
    const { columns, title, selectedItem, showForm, startDate, endDate, selectedCampaign, lastActionedLead, showRefundTermsAgreement, lastActionRequested  } = this.state 
    const { classes, commonStore } = this.props
    const { leadScrollID, leadsTotal, loading, agent } = commonStore
 
    let lead = null
    if(lastActionedLead){
       lead = this.getLead(lastActionedLead)
    }

    return (
        <div className={classes.root}>
        <SonicGrid 
        rowData={this.createDataArray()} 
        columnData={columns} 
        title={title} 
        checkbox={false} 
        rowsSelected={this.itemSelected}
        selectedCampaign={selectedCampaign}
        defaultDateRange={{startDate, endDate}}
        campaignSelected={this.campaignSelected}
        lastResultSelected={this.lastResultSelected}
        filterSelected={this.filterSelected}
        searchDatesUpdated={this.searchDatesUpdated}
        searchDate={this.getItems}
        updateItem={this.updateItem}
        searchMore={this.searchMore}
        totalItems={leadsTotal}
        scrollID={leadScrollID}
        loading={loading}
        />
        {/*showForm ? <LeadFormDialog  values={ selectedItem ? selectedItem : {} } open={ showForm } handleClose={this.handleCloseForm} /> : null */}
       
        <RefundAgreement lead={{...agent, ...lead}} lastResult={lastActionRequested} open={showRefundTermsAgreement}  handleClose={this.handleRefundTermsAgreementClose} />
       
        </div>
      );
    }
  }

  export default withStyles(styles)(Leads);


// WEBPACK FOOTER //
// ./src/components/Leads/Leads.js